var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { AspectInteractTimed } from './interact/AspectInteractTimed';
import { memoize } from '../../../utils/mobx/decorators/memoize';
export class AspectInteract {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get aspect() {
        return this.parent;
    }
    get app() {
        return this.parent.context.app;
    }
    get actor() {
        return this.parent.actor;
    }
    get latest() {
        return this.aspect.aspectEvents.latestEventOfType;
    }
    get isAspectHovering() {
        const { mouseenter, mouseleave } = this.latest;
        if (!mouseenter)
            return false;
        if (!mouseleave)
            return true;
        return mouseenter.runtimeTime > mouseleave.runtimeTime;
    }
    get isAspectActive() {
        const { mousedown, mouseup } = this.latest;
        return mousedown.runtimeTime > mouseup.runtimeTime;
    }
    get isAspectFocused() {
        const { focus, blur } = this.latest;
        if (!focus)
            return false;
        if (!blur)
            return true;
        return focus.runtimeTime > blur.runtimeTime;
    }
    get timedInteract() {
        return new AspectInteractTimed(this);
    }
}
__decorate([
    computed
], AspectInteract.prototype, "isAspectHovering", null);
__decorate([
    computed
], AspectInteract.prototype, "isAspectActive", null);
__decorate([
    computed
], AspectInteract.prototype, "isAspectFocused", null);
__decorate([
    memoize
], AspectInteract.prototype, "timedInteract", null);
